module.exports = __webpack_public_path__ + "static/img/tube_landing_07.cee17e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tube_landing_07.jpg
// module id = p3cd
// module chunks = 0